// AdminDashboard.js

import React from 'react';
import StripePayment from './StripePayments';
import AddUser from './AddUser';
import ApiKeyManager from './ApiKeyManager';
import './AdminDashboard.css';

const fetchWithAuth = async (url, options = {}) => {
  let token = localStorage.getItem('token');
  const response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  return response;
};

const AdminDashboard = () => {
  return (
    <div className="admin-dashboard">
      <h2>Profile Overview</h2>
      <div className="payment-section">
        <StripePayment />
      </div>
      <div className="user-section">
        <AddUser fetchWithAuth={fetchWithAuth} />
      </div>
      <div className="api-key-section">
        <ApiKeyManager fetchWithAuth={fetchWithAuth} />
      </div>
    </div>
  );
};

export default AdminDashboard;
